import { customScrollbar } from '@welbe/web-design-system';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	font-style: normal;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_primary_lightest_title};
`;

export const Alert = styled.div`
	background-color: #e8eff7;
	border-radius: 6px;
	width: 100%;
	padding: 10px 16px;
	gap: 16px;
	display: flex;
	align-items: center;
`;

export const InputWrapper = styled.div`
	display: flex;
	gap: 15px;
	align-items: center;
	margin-bottom: 6px;
`;

export const Footer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 24px;
	width: 100%;
`;

export const MainFields = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 40px;
	row-gap: 24px;

	${customScrollbar}
`;
